import React from 'react';
import BoxButton from '@/components/FileViewer/@components/BoxButton';
import ToolbarTooltip from '@/components/FileViewer/@components/ToolbarTooltip';
import RotateIcon from '@/public/icons/files/rotate.svg';

interface RotateButtonProps {
  onRotate: () => void;
  disabled?: boolean;
}

const RotateButton: React.FC<RotateButtonProps> = ({
  onRotate,
  disabled = false,
}) => {
  return (
    <ToolbarTooltip title="90도 회전">
      <BoxButton
        icon={<RotateIcon />}
        boxSize={48}
        iconSize={24}
        onClick={onRotate}
        disabled={disabled}
      />
    </ToolbarTooltip>
  );
};

export default RotateButton;
